import { useState } from 'react';
import axios from 'axios';
import './ContactPage.css';
import contactBanner from '../images/banner-contacus.jpg';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import MyFooter from './MyFooter';
import GoogleMapComponent from './GoogleMapComponent';
import ApplicationsList from './ApplicationsList';

const ContactPage = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Send form data to Laravel API
      const response = await axios.post(`${API_BASE_URL}/api/contacts`, {
        name: formData.name,
        mobile: formData.mobile,
        message: formData.message
      });

      console.log('Form submitted successfully:', response.data);
      alert('Thank you for your message!');
      
      // Reset form
      setFormData({
        name: '',
        mobile: '',
        message: ''
      });

    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to send message. Please try again.');
    }
  };

  return (
    <div data-aos="fade-up" className="contact-page">
      {/* Banner Section */}
      <div className="contact-banner">
        <img src={contactBanner} alt="Contact Us" />
        <div className="banner-overlay">
          <h1>Contact Us</h1>
          <p>We're here to help and answer any questions</p>
        </div>
      </div>

      {/* Main Content */}
      <div data-aos="fade-up" className="contact-container">
        {/* Contact Info Section */}
        <div className="contact-info">
          <div className="info-item">
            <FaMapMarkerAlt className="info-icon" />
            <div>
              <h3>Our Location</h3>
              <p>Sub Station Road, Cherani</p>
              <p>Manjeri, Kerala-676123</p>
            </div>
          </div>
          
          <div className="info-item">
            <FaPhone className="info-icon" />
            <div>
              <h3>Phone</h3>
              <p>+91 9605767367</p>
            </div>
          </div>
          
          <div className="info-item">
            <FaEnvelope className="info-icon" />
            <div>
              <h3>Email</h3>
              <p>manjeripalliative@gmail.com</p>
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Send Us a Message</h2>
          <div className="form-group">
            <label>Name</label>
            <input 
              type="text" 
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Mobile</label>
            <input 
              type="tel" 
              value={formData.mobile}
              onChange={(e) => setFormData({...formData, mobile: e.target.value})}
              required
              placeholder="+91 1234567890"
            />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea 
              value={formData.message}
              onChange={(e) => setFormData({...formData, message: e.target.value})}
              required
            ></textarea>
          </div>
          <button type="submit">Send Message</button>
        </form>
      </div>

      {/* Google Map Section */}
    
      <GoogleMapComponent/>

    </div>
  );
};

export default ContactPage;